import PageComponent from '../../common/component/page-component';

import Input from './util/input';

class ProjectionCalculator extends PageComponent {

	constructor({
					root,
					element
				}) {
		super({root: root, element: element});

		this.distance = 800;
		this.size = 200;
		this.lenses = null;
		this.focals = null;
		this.masks = null;
		this.usages = null;
		this.lenseimages = null;
		this.focalLengths = [];
		this.distanceRangeInput = null;
		this.distanceNumberInput = null;
		this.sizeRangeInput = null;
		this.sizeNumberInput = null;

		this.maxSizeValueEl = null;
		this.minDistanceValueEl = null;
		this.sizeRangeValueEl = null;
		this.distanceRangeValueEl = null;
		this.image = null;
	}

	prepare() {
		this.lenses = this.element.querySelectorAll('.js-slx-projcal__lense');
		this.focals = this.element.querySelectorAll('.js-slx-projcal__focal');
		this.masks = this.element.querySelectorAll('.js-slx-projcal__mask');
		this.usages = this.element.querySelectorAll('.js-slx-projcal__usage');
		this.lenseimages = this.element.querySelectorAll('.js-slx-projcal__lenseimage');
		this.maxSizeValueEl = this.element.querySelector('#slx-projcal__size-max');
		this.minDistanceValueEl = this.element.querySelector('#slx-projcal__distance-min');
		this.sizeRangeValueEl = this.element.querySelector('#slx-projcal__size-value');
		this.distanceRangeValueEl = this.element.querySelector('#slx-projcal__distance-value');
		this.image = this.element.querySelector('#js-slx-projcal__image');

		for (const lense of this.lenses) {
			const focalLength = parseInt(lense.getAttribute('data-focallength'), 10);
			this.focalLengths.push(focalLength);
		}

		const distanceRangeInputEl = this.element.querySelector('.js-slx-projcal__distance-input');
		this.distanceRangeInput = new Input({el: distanceRangeInputEl});
		this.distanceRangeInput.start();
		this.distanceRangeInput.setValue(this.distance / 100);
		this.distanceRangeInput.events.on('change', this.onDistanceChange.bind(this));

		const distanceNumberInputEl = this.element.querySelector('.js-slx-projcal__distance-input-number');
		this.distanceNumberInput = new Input({el: distanceNumberInputEl});
		this.distanceNumberInput.start();
		this.distanceNumberInput.setValue(this.distance / 100);
		this.distanceNumberInput.events.on('blur', this.onDistanceChange.bind(this));

		const sizeRangeInputEl = this.element.querySelector('.js-slx-projcal__size-input');
		this.sizeRangeInput = new Input({el: sizeRangeInputEl});
		this.sizeRangeInput.start();
		this.sizeRangeInput.setValue(this.size / 100);
		this.sizeRangeInput.events.on('change', this.onSizeChange.bind(this));

		const sizeNumberInputEl = this.element.querySelector('.js-slx-projcal__size-input-number');
		this.sizeNumberInput = new Input({el: sizeNumberInputEl});
		this.sizeNumberInput.start();
		this.sizeNumberInput.setValue(this.size / 100);
		this.sizeNumberInput.events.on('blur', this.onSizeChange.bind(this));

		this.update();
	}

	updateInput() {
		this.maxSizeValueEl.textContent = `max. ${(this.maxPojectionSize(45, this.distance) / 100).toLocaleString('de-DE')} m`;
		this.sizeRangeInput.el.setAttribute('max', this.maxPojectionSize(45, this.distance) / 100);

		this.minDistanceValueEl.textContent = `min. ${(this.minDistance(45, this.size) / 100).toLocaleString('de-DE')} m`;
		this.distanceRangeInput.el.setAttribute('min', this.minDistance(45, this.size) / 100);

		this.distanceRangeInput.setValue(this.distance / 100);
		this.distanceNumberInput.setValue(this.distance / 100);
		this.sizeNumberInput.setValue(Math.round(this.size) / 100);
		this.sizeRangeInput.setValue(Math.round(this.size) / 100);
	}

	updateImage() {
		this.image.setAttribute('style', `left:${(100 * 0.89) - Math.round(this.distance / 25) * 0.78}%`);
	}


	update() {
		this.updateInput();
		this.updateColumn(this.lenses);
		this.updateColumn(this.focals);
		this.updateColumn(this.masks);
		this.updateColumn(this.usages);
		this.updateColumn(this.lenseimages);
		this.updateMasks();
		this.updateImage();
	}

	updateColumn(elements) {
		let bestItem;
		for (const item of elements) {
			const focalLength = parseInt(item.getAttribute('data-focallength'), 10);
			item.classList.remove('slx-projcal--best');
			if (this.size > this.maxPojectionSize(focalLength, this.distance)) {
				item.classList.add('slx-projcal--disabled');
			} else {
				bestItem = item;
				item.classList.remove('slx-projcal--disabled');
			}
		}
		if (bestItem !== undefined) {
			bestItem.classList.add('slx-projcal--best');
		}
	}

	updateMasks() {
		for (const item of this.masks) {
			const focalLength = parseInt(item.getAttribute('data-focallength'), 10);
			if (this.imageSize(focalLength) > 40) {
				item.textContent = '> 40 mm';
			} else {
				item.textContent = `${this.imageSize(focalLength)} mm`;
			}
		}
	}

	onDistanceChange(value) {
		if (!isNaN(parseFloat(value))) {
			if (this.size < this.maxPojectionSize(45, parseFloat(value) * 100)) {
				this.distance = parseFloat(value) * 100;
				this.size = Math.min(this.size, this.maxPojectionSize(45, this.distance));
			}
		}
		this.update();
	}

	onSizeChange(value) {
		if (!isNaN(parseFloat(value))) {
			//accept input
			this.size = Math.min(parseFloat(value) * 100, this.maxPojectionSize(45, this.distance));
		}
		this.update();
	}

	maxPojectionSize(focallength, dist) {
		const imagesize = 40; //mm
		return Math.round(imagesize * ((dist * 1000) - (1 * focallength)) / (focallength * 1000));
	}

	minDistance(focallength, si) {
		const imagesize = 40; //mm
		return Math.round((si * (focallength * 1000) / imagesize + (1 * focallength)) / 1000);
	}

	imageSize(focallength) {
		return Math.round((this.size * focallength * 1000) / ((this.distance * 1000) - (1 * focallength)));
	}

}

export default ProjectionCalculator;
